import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import UserAvatar from "../../Atoms/Templates/UserAvatar";
import DropdownButton from "../Dropsdown/DropdownButton";
import DropdownItem from "../../Atoms/Items/DropdownItem";
import Badge from "../../Atoms/Badge";
import DeleteModal from "../../Organisms/Modals/DeleteModal";
import {getUserType} from "../../../helpers/get-user-type";

const UserItem = props => {
  const { type } = props

  const userType = getUserType(type)

  const deleteModal = useRef()
  const handleOpenDeleteModal = () => {
    deleteModal.current.openModal()
  }

  return (
    <>
      <article className="s-mb-0 s-cross-start nowrap">
        <UserAvatar className="s-mr-8px" />
        <div className="s-mr-4px">
          <p className="s-mb-0 small">Evelyn Castrejón Jiménez</p>
          <div className="s-cross-start nowrap">
            <p className="s-mb-0 smaller s-color-light-text s-mr-8px">evelyn@discord.com</p>
            <Badge
              text={userType.rol}
              color={userType.color}
            />
          </div>
        </div>
        <DropdownButton
          className="s-to-right"
          icon="vertical-dots"
        >
          <DropdownItem text="Cambiar Rol" />
          <DropdownItem text="Eliminar" onClick={handleOpenDeleteModal} />
        </DropdownButton>
      </article>
      <DeleteModal
        ref={deleteModal}
      />
    </>
  );
};

UserItem.propTypes = {

};

export default UserItem;
